/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IEdmModel } from '../../models/i-edm-model';

export interface OdataMetadata$JsonOdataMetadataNone$Params {
}

export function odataMetadata$JsonOdataMetadataNone(http: HttpClient, rootUrl: string, params?: OdataMetadata$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
  const rb = new RequestBuilder(rootUrl, odataMetadata$JsonOdataMetadataNone.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IEdmModel>;
    })
  );
}

odataMetadata$JsonOdataMetadataNone.PATH = '/odata/$metadata';
